const Mutations = Object.freeze({
	SET_LOADING: 'projectSettings/dataFields/SET_LOADING',
	SET_ENTITIES: 'projectSettings/dataFields/SET_ENTITIES',
	SET_SELECTED_ENTITY: 'projectSettings/dataFields/SET_SELECTED_ENTITY',
	SET_DATA_FIELDS: 'projectSettings/dataFields/SET_DATA_FIELDS',
});

export const Actions = Object.freeze({
	LOAD_ENTITIES: 'projectSettings/dataFields/LOAD_ENTITIES',
	LOAD_SELECTED_ENTITY: 'projectSettings/dataFields/LOAD_SELECTED_ENTITY',
	ADD_ENTITY: 'projectSettings/dataFields/ADD_ENTITY',
	CREATE_INDEX: 'projectSettings/dataFields/CREATE_INDEX',
	REMOVE_INDEX: 'projectSettings/dataFields/REMOVE_INDEX',
	CLEAR: 'projectSettings/dataFields/CLEAR',
});

export const Getters = Object.freeze({
	GRID_LOADING: 'projectSettings/GRID_LOADING',
	GET_ENTITIES: 'projectSettings/GET_ENTITIES',
	DATA: 'projectSettings/DATA',
});

import dataService from '../../../../../services/data/projectSettingsService';
import { GeneralActions, GridsActions } from '../../../../actions';
export default {
	state: {
		entities: [],
		selectedEntity: null,
		dataFields: [],
		loading: false,
	},
	mutations: {
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_ENTITIES](state, items) {
			state.entities = items;
		},
		[Mutations.SET_SELECTED_ENTITY](state, item) {
			state.selectedEntity = item;
		},
		[Mutations.SET_DATA_FIELDS](state, items) {
			state.dataFields = items;
		},
	},
	actions: {
		[Actions.LOAD_ENTITIES]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dataService
					.getEntities()
					.then((resp) => {
						commit(Mutations.SET_ENTITIES, resp.data);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},
		[Actions.ADD_ENTITY]({ dispatch }, entity) {
			dispatch(GeneralActions.LOADING, true);
			return new Promise((resolve) => {
				dataService
					.addEntity(entity)
					.then(() => {
						return Promise.all([
							dispatch(Actions.LOAD_ENTITIES),
							dispatch(GridsActions.RELOAD_ENTITIES),
						]);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},
		[Actions.LOAD_SELECTED_ENTITY]({ commit, dispatch }, entity) {
			commit(Mutations.SET_LOADING, true);
			commit(Mutations.SET_DATA_FIELDS, []);
			commit(Mutations.SET_SELECTED_ENTITY, entity);
			return new Promise((resolve) => {
				dataService
					.getDataFieldsByEntityId(entity.Id)
					.then((resp) => {
						commit(Mutations.SET_DATA_FIELDS, resp.data);
						commit(Mutations.SET_LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.CREATE_INDEX]({ dispatch }, dataField) {
			dispatch(GeneralActions.LOADING, true);
			return new Promise((resolve) => {
				dataService
					.addDataFieldDbIndex(dataField)
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dataField.HasIndex = false;
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},
		[Actions.REMOVE_INDEX]({ dispatch }, dataField) {
			dispatch(GeneralActions.LOADING, true);
			return new Promise((resolve) => {
				dataService
					.addDataFieldDbIndex(dataField)
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dataField.HasIndex = true;
						dispatch(GeneralActions.LOADING, false);
						dispatch(GeneralActions.ERROR, error);
						resolve();
					});
			});
		},
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_DATA_FIELDS, []);
				commit(Mutations.SET_SELECTED_ENTITY, null);
				commit(Mutations.SET_ENTITIES, []);
				commit(Mutations.SET_LOADING, false);
				resolve();
			});
		},
	},
	getters: {
		[Getters.GRID_LOADING]: (state) => {
			return state.loading;
		},
		[Getters.DATA]: (state) => {
			if (state.dataFields && state.dataFields.length > 0) {
				return JSON.parse(JSON.stringify(state.dataFields));
			}
			return [];
		},
		[Getters.GET_ENTITIES]: (state) => {
			if (state.entities && state.entities.length > 0) {
				return JSON.parse(
					JSON.stringify(
						state.entities.sort((a, b) =>
							a.Name > b.Name ? 1 : -1
						)
					)
				);
			}
			return [];
		},
	},
};
